export enum C4CSalesItemType {
  OTEL_YURT_ICI_SEHIR = 'OtelYurtIciSehir',
  TUR_CRUISE = 'TurCruise',
  TUR_KULTUR = 'TurKultur',
  OTEL_YURT_ICI = 'OtelYurtIci',
  TUR_YURT_DISI = 'TurYurtDisi',
  OTEL_YURT_DISI = 'OtelYurtDisi',
  OTEL_AVAILABILITY_STATUS = 'OtelAvailabilityStatus',
  KIBRIS = 'Kibris',
}
